export default "/images/vendor/@coreui/icons/svg/flag/cif-zw.svg?47c6a53d3b9aeb1dae363d4a081ecb85";